import { Organization } from "@/types/Organization";
import { makeLocalStorageVar } from "./LocalStorageReactiveVar";

export const organizationsVar = makeLocalStorageVar<Organization[] | null>(
  "organizations",
  null,
);
